export const multiDialogAction = {
    add: "add",
    delete: "delete",
    edit: "edit",
    enable: "ripristinaAll",
    disable: "disableRangeData"
}